import React from "react";
import {TextToSpeachIcon} from "@hugeicons/core-free-icons";
import {MiniCard} from "./MiniCard";
import {PeriodMenu} from "./PeriodMenu";
import {ResponseTimeNavigation} from "./ResponseTimeNavigation";
import {useDashboard} from "../../../../context/DashboardContext";
import {formatSeconds, hasActivity, toChartData} from "./response-time-utils";

export const TextToSpeechCard = () => {
    const {responseTime} = useDashboard();
    const statistic = responseTime?.TEXT_TO_SPEECH;
    const chartData = toChartData(statistic);

    return (
        <MiniCard
            icon={TextToSpeachIcon}
            color={"#dd9230"}
            title={formatSeconds(statistic)}
            subtitle={"TEXT TO SPEECH"}
            data={chartData}
            hideChart={!hasActivity(chartData)}
            action={<PeriodMenu type={"TEXT_TO_SPEECH"}/>}
            chartOverlay={<ResponseTimeNavigation type={"TEXT_TO_SPEECH"}/>}
        />
    );
};
